exports.install = function (Vue, options) {
    Vue.prototype.meddd = function () {//全局函数1
        if (this.viewwidth < 900) {
            this.isCollapse = true
            this.asdewidth = '57px'
            this.shrinks = 1
        }
    };
    Vue.prototype.shrink = function () {//全局函数2
        this.isCollapse = true
        this.asdewidth = '57px'
        this.shrinks = 1
    };
    Vue.prototype.unfold = function () {//全局函数2
        this.isCollapse = false
        this.asdewidth = '221px'
        this.shrinks = 2
    };
    Vue.prototype.adminlogout = function () {//全局函数2
        this.$store.commit('logout');
        var exdate=new Date();//获取时间
        var exdays = -1;
        exdate.setTime(exdate.getTime() + 86400*1000*exdays);//保存的天数
        window.document.cookie="UP"+"="+""+";path=/;expires="+exdate.toGMTString();
        this.$router.push({ name: "login", params: { zidong: 88 }})
    };
  //date日期转字符串日期
  Vue.prototype.formatDateString=function(date){
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    var minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    return y + '年' + m + '月' + d+'日';
  };
  /* 时间戳转字符型日期*/
  Vue.prototype.toDate = function (date) {

    if(!date){
      return "无"
    }
    Date.prototype.toLocaleString = function() {
      return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate() + " " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds();
    };
    var unixTimestamp = new Date(date * 1000)
    return unixTimestamp.toLocaleString();
  };
  //日期字符串转date日期
  Vue.prototype.parserDate=function(date) {
    var t = Date.parse(date);
    if (!isNaN(t)) {
      return new Date(Date.parse(date.replace(/-/g, "/")));
    } else {
      return new Date();
    }
  };
};



// WEBPACK FOOTER //
// ./src/system/base.js